// components/LocationMarkers.js
import React from 'react';
import { Marker, Popup } from 'react-leaflet';
import { Typography, Box } from '@mui/material';
import { createCustomIcon, formatCurrency } from './helpers';

export const LocationMarkers = ({
  filteredLocations,
  getBusinessUnit,
  selectedVendors,
  VENDOR_COSTS,
  onLocationSelect // Add this prop
}) => (
  <>
    {filteredLocations.map((location, index) => {
      const businessUnit = getBusinessUnit(location.abbreviation);
      return (
        <Marker
          key={`${location.abbreviation}-${index}`}
          position={[location.position.lat, location.position.lng]}
          icon={createCustomIcon(businessUnit)}
          eventHandlers={{
            click: () => {
              console.log('Marker clicked:', location);
              onLocationSelect(location);
            }
          }}
        >
          <Popup>
            <div>
              <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                {location.businessName}
              </Typography>
              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                ({location.abbreviation}) - {businessUnit}
              </Typography>
              <Typography variant="body2">{location.address}</Typography>
              {location.size !== 'NA' && (
                <Box sx={{ mt: 1 }}>
                  <Typography variant="body2">
                    <strong>Site Type:</strong> {location.size}
                  </Typography>
                  {selectedVendors.map((vendor) => (
                    <Typography key={vendor} variant="body2">
                      <strong>{vendor}:</strong>{' '}
                      {formatCurrency(VENDOR_COSTS[vendor][location.size])}
                    </Typography>
                  ))}
                </Box>
              )}
            </div>
          </Popup>
        </Marker>
      );
    })}
  </>
);